import { t } from "@lingui/macro";
import axios from "axios";

export function encodeQueryData(data: Record<string, any>) {
  const ret: string[] = [];
  Object.keys(data).forEach((d) => {
    ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(String(data[d])));
  });
  return ret.join("&");
}

export type ApiError = Error & {
  status?: number;
  code?: string;
  body?: unknown;
};

export function handleApiError(error: unknown): ApiError {
  if (axios.isAxiosError(error)) {
    const body = error.response?.data as { message?: string; code?: string } | undefined;
    const err = new Error(body?.message || t`Something went wrong with our system. Please try again!`) as ApiError;
    err.status = error.response?.status;
    err.code = body?.code;
    err.body = body;
    return err;
  }

  return new Error((error as any)?.message || t`Something went wrong with our system. Please try again!`) as ApiError;
}
